import { render, staticRenderFns } from "./SeStdTaxFormW2.vue?vue&type=template&id=0cdab526"
import script from "./SeStdTaxFormW2.vue?vue&type=script&lang=js"
export * from "./SeStdTaxFormW2.vue?vue&type=script&lang=js"
import style0 from "./SeStdTaxFormW2.vue?vue&type=style&index=0&id=0cdab526&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports